<template>
  <div class="sm:min-h-screen bg-gray-50 flex flex-col justify-center sm:py-12 sm:px-6 lg:px-8">
    <div class="sm:mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 relative">
        <div class="sm:block absolute top-0 right-0 pt-4 pr-4">
          <button aria-label="Close"
                  class="focus:outline-none transition ease-in-out duration-150 text-sm"
                  :class="otpLoad ? 'text-gray-500 pointer-events-none' : 'text-red-400 hover:text-red-500 focus:text-red-500'"
                  :disabled="otpLoad" @click.prevent="cancelSession">Cancel</button>
        </div>
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100">
          <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 32 32"
               xmlns="http://www.w3.org/2000/svg">
            <path class="st0"
                  d="M20,17h-8c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h8c1.1,0,2,0.9,2,2v4C22,16.1,21.1,17,20,17z"/>
            <path class="st0" d="M20,9h-8V5c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4V9z"/>
            <line class="st0" x1="16" x2="16" y1="12" y2="14"/>
            <line class="st0" x1="16" x2="16" y1="22" y2="25"/>
            <line class="st0" x1="13.1" x2="16" y1="24.1" y2="25"/>
            <line class="st0" x1="14.2" x2="16" y1="27.4" y2="25"/>
            <line class="st0" x1="17.8" x2="16" y1="27.4" y2="25"/>
            <line class="st0" x1="18.9" x2="16" y1="24.1" y2="25"/>
            <line class="st0" x1="26" x2="26" y1="22" y2="25"/>
            <line class="st0" x1="23.1" x2="26" y1="24.1" y2="25"/>
            <line class="st0" x1="24.2" x2="26" y1="27.4" y2="25"/>
            <line class="st0" x1="27.8" x2="26" y1="27.4" y2="25"/>
            <line class="st0" x1="28.9" x2="26" y1="24.1" y2="25"/>
            <line class="st0" x1="6" x2="6" y1="22" y2="25"/>
            <line class="st0" x1="3.1" x2="6" y1="24.1" y2="25"/>
            <line class="st0" x1="4.2" x2="6" y1="27.4" y2="25"/>
            <line class="st0" x1="7.8" x2="6" y1="27.4" y2="25"/>
            <line class="st0" x1="8.9" x2="6" y1="24.1" y2="25"/>
          </svg>
        </div>
        <div class="mt-5">
          <h3 id="modal-headline" class="text-lg leading-6 text-center font-medium text-gray-900">
            Authorize your payment
          </h3>
          <div class="mt-6 sm:mt-5 sm:grid sm:grid-cols-5 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
            <p class="block text-sm leading-5 sm:mt-px sm:pt-2">
              Merchant name:
            </p>
            <div class="mt-1 sm:mt-0 sm:col-span-3">
              <p class="mt-2 text-sm">{{paymentInformation.activityName}}</p>
            </div>
          </div>
          <div class="mt-6 sm:mt-1 sm:grid sm:grid-cols-5 sm:gap-0 sm:items-start">
            <p class="block text-sm leading-5   sm:mt-px sm:pt-2">
              Amount:
            </p>
            <div class="mt-1 sm:mt-0 sm:col-span-4">
              <p class="mt-2 text-sm">OMR {{ (paymentInformation.amount / 1000).toFixed(3) }}</p>
            </div>
          </div>
          <div class="mt-6 sm:mt-1 sm:grid sm:grid-cols-5 sm:gap-0 sm:items-start">
            <p class="block text-sm leading-5   sm:mt-px sm:pt-2">
              Card:
            </p>
            <div class="mt-1 sm:mt-0 sm:col-span-4">
              <p class="mt-2 text-sm">{{ paymentInformation.paymentMethod }}</p>
            </div>
          </div>
        </div>
        <validation-observer ref="otpForm">
          <form @submit.prevent="ProceedWithOTP">
            <div class="mt-6">
              <label for="otp" class="block text-sm font-medium leading-5 text-gray-700">
                Please enter your OTP received from bank
              </label>
              <div class="mt-1 rounded-md shadow-sm relative">
                <validation-provider
                    v-slot="{ failed, errors }"
                    name="otp"
                    rules="required"
                >
                  <input inputmode="numeric"
                         v-model="otpModel.otp"
                         :class=" !failed ? '' : 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red'"
                         v-cleave="{
                                      blocks: [6],
                                      numericOnly: true,
                                    }" autocomplete="off" id="otp" type="text" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                  <p
                      id="otp-error"
                      class="absolute top-10 left-0 text-xs text-red-600 text-right normal-case"
                  >
                    {{ errors[0] }}
                  </p>
                </validation-provider>
              </div>
            </div>
            <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <button :disabled="otpLoad || isSuccess || isFailed"
                      type="submit"
                      class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white  focus:outline-none transition duration-150 ease-in-out"
                      :class="buttonClass"
              >
                <span v-show="!otpLoad && !isSuccess && !isFailed">
                        Verify
                      </span>
                <svg
                    v-show="otpLoad"
                    class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            fill="currentColor"
                        ></path>
                      </svg>
                <span v-show="otpLoad"> Verifying </span>
                <span v-show="isSuccess"> Successful </span>
                <span v-show="isFailed"> Payment failed </span>
              </button>
            </span>
            </div>
          </form>
        </validation-observer>

      </div>
    </div>
          <powered-by></powered-by>
  </div>
</template>

<script>
import PoweredBy from '@/components/PoweredBy'
import Checkout from '@/API/Checkout'
const checkout = new Checkout()
export default {
  name: 'Authorize',
  components: {
    PoweredBy
  },
  data () {
    return {
      paymentInformation: {
        amount: 0,
        paymentMethod: '',
        activityName: '',
        returnUrl: ''
      },
      otpLoad: false,
      isSuccess: false,
      isFailed: false,
      buttonClass: 'bg-indigo-600 hover:bg-indigo-500 focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700',
      otpModel: {
        key: '',
        paymentIntentId: '',
        clientSecret: '',
        invoice: '',
        otp: ''
      }
    }
  },
  methods: {
    async ProceedWithOTP () {
      const result = await this.$refs.otpForm.validate()
      if (!result) {
        return
      }
      try {
        this.otpLoad = true

        const otpResponse = await checkout.ConfirmPaymentIntentOtpAsync(
          this.otpModel.key,
          this.otpModel.paymentIntentId,
          this.otpModel.clientSecret,
          this.otpModel.invoice,
          this.otpModel.otp
        )
        if (otpResponse.data.success) {
          this.otpLoad = false
          this.isSuccess = true
          this.buttonClass = 'bg-green-500'
          setTimeout(() => {
            window.location.href = this.paymentInformation.returnUrl
          }, 1500)
        } else if (!otpResponse.data.success && otpResponse.data.code === 4206) {
          this.$refs.otpForm.setErrors({
            otp: ['Your card otp failed! please try again']
          })
          this.otpModel.invoice = otpResponse.data.message
          this.otpModel.otp = ''
          this.otpLoad = false
          this.buttonClass = 'bg-indigo-600 hover:bg-indigo-500 focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700'
        } else {
          this.buttonClass = 'bg-red-500'
          this.otpLoad = false
          this.isFailed = true
          this.$refs.otpForm.setErrors({
            otp: ['Payment failed, could not charge your card use a different card']
          })
          setTimeout(() => {
            window.location.href = this.paymentInformation.returnUrl
          }, 2500)
        }
      } catch (ex) {
        this.otpModel.otp = ''
        this.otpLoad = false
        this.isFailed = false
        this.isSuccess = false
      }
    },
    async cancelSession () {
      await checkout.cancelPaymentIntentAsync(
        this.otpModel.paymentIntentId,
        this.otpModel.clientSecret
      )
      window.location.href = this.paymentInformation.returnUrl
    }
  },
  async mounted () {
    const result = checkout.ExtractUrlJson(this.$route.params.paymentIntent)
    this.otpModel = {
      key: result.key,
      paymentIntentId: result.payment_intent_id,
      clientSecret: result.client_secret,
      invoice: result.invoice
    }
    try {
      const response = await checkout.getPaymentIntentDetailsAsync(
        result.payment_intent_id,
        result.key,
        result.client_secret
      )
      this.paymentInformation = {
        amount: response.data.amount,
        paymentMethod: response.data.payment_method,
        activityName: response.data.activity_name,
        returnUrl: response.data.return_url
      }
    } catch (ex) {
    }
  }
}
</script>

<style scoped>

</style>
